import React from 'react'
import { OverlayDiv } from './index.styled'

const Overlay = ({ light = false, ...props }) => {
  return <OverlayDiv className={light && 'light'} aria-hidden="true" {...props} />
}
export default Overlay
